import { Reveal } from '../components/effects/Reveal';
import { Spotlight } from '../components/effects/Spotlight';

const DIFFS = [
  {
    num: '01',
    tag: 'Élite',
    title: 'Consultora tecnológica de élite, no fábrica',
    desc: 'Atención directa de Directores y Gerentes, sin capas intermedias entre la decisión y la ejecución.',
    icon: <path d="M12 2l4 6h7l-5.5 4 2.5 8L12 16l-8 4 2.5-8L1 8h7z" />,
  },
  {
    num: '02',
    tag: 'Retención',
    title: 'Talento que se queda',
    desc: 'Retención >90% — el promedio nacional es 68-74%. Tu proyecto no se interrumpe con rotación.',
    icon: (
      <>
        <path d="M16 11a4 4 0 11-8 0 4 4 0 018 0z" />
        <path d="M3 21c0-4 4-7 9-7s9 3 9 7" />
      </>
    ),
  },
  {
    num: '03',
    tag: 'Velocidad',
    title: 'Velocidad real',
    desc: 'Senior en 15 días, mid en 12, junior en 7. La industria tarda 30-45.',
    icon: <path d="M13 2L4 14h6l-1 8 9-12h-6z" />,
  },
  {
    num: '04',
    tag: 'Validación',
    title: 'Validados por los líderes',
    desc: '+25 certificaciones Cloud, partnerships con AWS, Azure y Snowflake.',
    icon: (
      <>
        <path d="M9 12l2 2 4-4" />
        <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />
      </>
    ),
  },
];

export default function Differentiators() {
  return (
    <section className="on-blue bg-etribe-blue text-white py-[120px] relative overflow-hidden">
      {/* Background ambient */}
      <div
        aria-hidden
        className="absolute inset-0 -z-10 pointer-events-none opacity-60"
        style={{
          background:
            'radial-gradient(40% 30% at 100% 0%, rgba(255,200,54,.10), transparent 60%), radial-gradient(40% 30% at 0% 100%, rgba(50,127,239,.10), transparent 60%)',
        }}
      />

      <div className="container-etribe">
        <Reveal>
          <div className="max-w-[720px] mb-16">
            <p className="eyebrow"><span>Diferenciadores</span></p>
            <h2 className="text-[clamp(32px,3.6vw,48px)] text-white">Por qué trabajar con eTribe</h2>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {DIFFS.map((d, idx) => (
            <Reveal key={d.num} delay={idx * 100}>
              <Spotlight
                className="relative h-full rounded-[18px] bg-white/[0.04] border border-white/10 overflow-hidden group hover:-translate-y-2 hover:bg-white/[0.07] hover:border-etribe-yellow/30 transition-all duration-400"
                color="rgba(255, 200, 54, 0.15)"
                size={460}
              >
                <article className="relative p-8 lg:p-10 h-full flex flex-col" data-cursor="grow">
                  {/* Número gigante de fondo */}
                  <span
                    aria-hidden
                    className="absolute -top-4 -right-2 font-heading font-black text-[160px] leading-none text-white/[0.05] group-hover:text-etribe-yellow/[0.10] transition-colors duration-500 select-none pointer-events-none"
                  >
                    {d.num}
                  </span>

                  {/* Glow amarillo decorativo en hover */}
                  <span
                    aria-hidden
                    className="absolute -bottom-12 -left-12 w-40 h-40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                    style={{ background: 'radial-gradient(circle, rgba(255,200,54,.18), transparent 70%)' }}
                  />

                  {/* Eyebrow numerada */}
                  <div className="relative z-10 inline-flex items-center gap-2 mb-7">
                    <span className="font-heading text-[11px] tracking-[0.18em] text-etribe-yellow font-bold">
                      {d.num}
                    </span>
                    <span className="w-6 h-px bg-etribe-yellow" />
                    <span className="font-heading text-[11px] tracking-[0.18em] uppercase text-white/60">
                      {d.tag}
                    </span>
                  </div>

                  {/* Icon container (cuadro amarillo) — invierte al hacer hover */}
                  <div className="relative z-10 mb-7">
                    <div className="absolute inset-0 bg-etribe-yellow/20 rounded-[14px] blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    <div className="relative w-14 h-14 grid place-items-center text-etribe-yellow bg-etribe-yellow/15 group-hover:bg-etribe-yellow group-hover:text-etribe-blue group-hover:rotate-[-6deg] group-hover:scale-105 rounded-[14px] transition-all duration-400">
                      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                        {d.icon}
                      </svg>
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="relative z-10 text-white text-[20px] leading-[1.2] mb-4">
                    {d.title}
                  </h3>

                  {/* Divider amarillo animado */}
                  <span
                    aria-hidden
                    className="relative z-10 block h-0.5 w-10 bg-etribe-yellow mb-5 group-hover:w-20 transition-all duration-500"
                  />

                  {/* Description */}
                  <p className="relative z-10 text-white/75 text-sm leading-[1.6] flex-1 text-justify hyphens-auto">
                    {d.desc}
                  </p>
                </article>
              </Spotlight>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
